export default [
    '/sell/*',
    '/buy/*',
    '/profile/*',
    '/change-password',
    '/message-center',
    '/tech-support',
    '/resource-center',
]
